import { createTheme } from '@mui/material/styles'

declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    xs: false // removes the `xs` breakpoint
    sm: false
    md: false
  }
}

export const theme = createTheme({
  typography: {
    fontFamily: 'Roboto, Hiragino Kaku Gothic Pro',
    fontWeightLight: 200,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 600,
    fontSize: 16,
  },
  palette: {
    primary: {
      light: '#757de8',
      main: '#3f51b5',
      dark: '#002984',
    },
    // secondary: {},
    // warning: {},
    // error: {},
    info: {
      main: 'rgba(33, 150, 243, 1)',
    },
    // success: {},
    background: {
      default: 'rgba(247, 247, 247, 1)',
    },
    text: {
      primary: 'rgba(0, 0, 0, 0.87)',
      secondary: 'rgba(0, 0, 0, 0.6)',
    },
    divider: 'rgba(0, 0, 0, 0.23)',
  },
  breakpoints: {
    keys: ['lg'],
    values: {
      lg: 800,
      xl: 1280,
    },
  },
  components: {
    MuiTablePagination: {
      styleOverrides: {
        selectLabel: {
          fontSize: 12,
          fontStyle: 'normal',
          lineHeight: '19.92px',
          fontWeight: 'Regular',
          fontColor: 'rgba(0, 0, 0, 0.6)',
        },
        displayedRows: {
          fontSize: 12,
          fontStyle: 'normal',
          lineHeight: '19.92px',
          fontWeight: 'Regular',
          fontColor: 'rgba(0, 0, 0, 0.6)',
        },
      },
    },
  },
})
